angular.module('unica_campaign.campaign_controllers')

.controller('CampaignEditController', function(
	$rootScope, $scope, $state, $stateParams,
	CampaignEditService
) {

	$scope.event_id = $stateParams.event_id;
	$scope.id       = $stateParams.id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.getCampaignTemplateList();

	$scope.$on( 'campaign_template_list_loaded', function() {
		$scope.getCampaign( $stateParams.id );
	});


	$scope.saveCampaign = function()
	{
		$scope.showLoader();

		CampaignEditService
			.update( $scope.campaignData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Campagna aggiornta con successo!', '');

					//$state.go('app.hospitality.room_list', { event_id: $stateParams.event_id });
				}
			});
	};

});